import React from 'react';

function HeaderContent(props) {
    return (
        <div id="name" className=" font-bold pt-4 w-full justify-center justify-items-center">
            <h1 className="text-4xl font-rajdhani text-vlight-blue ">
                Moisés Ferreira e Silva
            </h1>
            <h2 className="text-lg font-league-spartan font-light text-main-text pr-4 pl-4">
                Fullstack Software Engineer | Flutter/Dart | Node.js | UI/UX Designer
            </h2>
        </div>
    )
}

export default HeaderContent;